import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export function sendCopyWishlist({ wishlistId }: { wishlistId: string }) {
  const apiUrl = resolveApiUrl(`/copyWishlistManual?wishlistId=${wishlistId}`);

  return fetch(apiUrl, {
    method: "GET",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
